import { cn, cssVars } from '@/lib/utils'

const LAYERS = [0, 1, 2] as const

/** Il marchio come tre lastre di vetro vere che galleggiano sopra la luce della sezione (decorativo). */
export function GlassStack({ className }: { className?: string }) {
  return (
    <div className={cn('glass-stack', className)} aria-hidden="true">
      {LAYERS.map((k) => (
        <span key={k} style={cssVars({ '--k': k })} />
      ))}
    </div>
  )
}
